import { translate } from "../helpers/translate";
export var ClientContractStatus;
(function (ClientContractStatus) {
    ClientContractStatus[ClientContractStatus["PendingSignature"] = 1] = "PendingSignature";
    ClientContractStatus[ClientContractStatus["Signed"] = 2] = "Signed";
    ClientContractStatus[ClientContractStatus["Approved"] = 3] = "Approved";
    ClientContractStatus[ClientContractStatus["Rejected"] = 4] = "Rejected";
    ClientContractStatus[ClientContractStatus["Reason"] = 5] = "Reason";
    ClientContractStatus[ClientContractStatus["Expired"] = 6] = "Expired";
})(ClientContractStatus || (ClientContractStatus = {}));
export const ClientContractStatusMap = new Map([
    [ClientContractStatus.PendingSignature, translate('enums.clientContractStatus.pendingSignature')],
    [ClientContractStatus.Signed, translate('enums.clientContractStatus.Signed')],
    [ClientContractStatus.Approved, translate('enums.clientContractStatus.approved')],
    [ClientContractStatus.Rejected, translate('enums.clientContractStatus.rejected')],
    [ClientContractStatus.Reason, translate('enums.clientContractStatus.reason')],
    [ClientContractStatus.Expired, translate('enums.clientContractStatus.Expired')]
]);
export const ClientContractStatusMapForFreelancer = new Map([
    [ClientContractStatus.PendingSignature, "Signature Pending"],
    [ClientContractStatus.Signed, "Review Contract"],
    [ClientContractStatus.Approved, "Contract Approved"],
    [ClientContractStatus.Rejected, "Contract Rejected"],
    [ClientContractStatus.Expired, "Expired"]
]);
export const ClientContractStatusMapForAdmin = new Map([
    [ClientContractStatus.PendingSignature, "Pending"],
    [ClientContractStatus.Signed, "Signed"],
    [ClientContractStatus.Approved, "Approved"],
    [ClientContractStatus.Rejected, "Rejected"],
    [ClientContractStatus.Reason, "Reason"],
    [ClientContractStatus.Expired, "Expired"]
]);
